/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import EmployeeLockScreenPresenter from './EmployeeLockScreenPresenter';
import DTOEmployeeLockScreen from './DTOEmployeeLockScreen';
import { userService } from '../../../api/services/userService';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import toast from 'react-hot-toast';
import { setAuthToken } from '../../../infra/aggregates/authTokenSlice';
import { setLoading } from '../../../infra/aggregates/LoaderSlice';
import { useTranslation } from 'react-i18next';
import { resetLogOutBtn } from '../../../infra/aggregates/myProfile/isHRViewSlice';
interface Props {
  isModalOpen: boolean;
  closeModal: any;
}

function EmployeeLockScreenController({ closeModal, isModalOpen }: Props) {
  const { t } = useTranslation();
  const trans = t;
  const selector = useAppSelector((state) => state.authSlice);
  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  const dispatch = useAppDispatch();
  const [data, setData] = useState<any>();

  const getLockScreenData = (data: any) => {
    setData(data);
  };
  const getPswrd = (pswrd: string) => {
    dispatch(setLoading(true));
    const username = selector.username;
    const payload = {
      username: username,
      password: pswrd,
      locale: localStorage.getItem('emplang'),
    };
    userService
      .login(payload)
      .then(() => {
        dispatch(setAuthToken(true));
        toast.success(trans('Welcome Back'));
        dispatch(setLoading(false));
        dispatch(resetLogOutBtn());
        closeModal();
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : err?.response?.data?.data,
        );
      });
  };
  return (
    <div>
      <DTOEmployeeLockScreen setLockScreenData={getLockScreenData} />
      <EmployeeLockScreenPresenter
        data={{ fullname: data?.fullname, profile_pic: data?.profile_pic }}
        setCallBackData={getPswrd}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        isLoading={isLoading}
        trans={t}
      />
    </div>
  );
}

export default EmployeeLockScreenController;
